import React from 'react';
import ReactDOM from 'react-dom';
import "./index.css"
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { BrowserRouter } from "react-router-dom";
import { persistedReducer } from './reducers/index';
import { ThemeProvider } from "@material-ui/core"
import { createTheme } from '@material-ui/core/styles';
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";

const store = createStore(persistedReducer, composeWithDevTools());
const persistor = persistStore(store);

const theme = createTheme({
  palette: {
    primary: {
      main: "#3ad1bf"
    },
    secondary: {
      main: "#df575c"
    },
    third: {
      main: ""
    }
  }
});

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store} >
      <PersistGate persistor={persistor}>
        <BrowserRouter>
          <ThemeProvider theme={theme}>
            <App />
          </ThemeProvider>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
